import React from "react";
import "../Styles/MyStory.css";
import NathanImage from "../assets/nate.png";

const MyStory = ({ scrollToSection }) => {
  return (
    <section className="my-story">
      <div className="container story-container">
        <div className="story-image reveal">
          <img src={NathanImage} alt="Nathanial Cadieux, founder of True Bloom Tutoring" />
        </div>

        <div className="story-content reveal">
          <p className="eyebrow">Our story</p>
          <h2 className="section-title">
            Meet Nathanial Cadieux
          </h2>
          <p className="section-lead">
            Founder of True Bloom Tutoring · Based in Airdrie · Serving Calgary &amp; Airdrie families
          </p>
          <p>
            I started tutoring in grade 11 while balancing school, soccer, and a part-time job.
            Growing up with a mother who taught for over 30 years gave me a clear view of how
            hard school can feel — and how powerful the right support can be.
          </p>
          <p>
            Now, as an architecture student at the University of Calgary, I lead a team of
            carefully selected university tutors. Together we support Alberta high school students
            with personalized sessions, currently helping 25+ students each week.
          </p>
          <div className="story-actions">
            <button className="btn btn-primary" onClick={() => scrollToSection("contact")}>
              Talk With Our Team
            </button>
            <button className="btn btn-secondary" onClick={() => scrollToSection("reviews")}>
              Read Parent Reviews
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyStory;
